import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import "../profile/booking.css";
import { websiteDetail } from "../../utils/common.data";
import { useBoardingDropping } from "../../context/BoardingDroppingContext";
import {
  adjustToStartOfDayIfGreater,
  handleRedirectUrl,
} from "../../utils/Functions";
// import BookingPageIcon from "../../assets/booking_view.jpg";
import BookingPageIcon from "../../assets/logo.png";
import "./style.css";
import SearchRideList from "./SearchRideList";
import citiesJson from "../../utils/cities";
import { Autocomplete, TextField, Typography } from "@mui/material";

const SearchRide = ({ handleBack }) => {
  const [err, setErr] = useState(false);
  const [address, setAddress] = useState("");
  const [bookingView, setBookingView] = useState(0);
  const [searchDetail, setSearchDetail] = useState({});

  const {
    ridePostBoardingDroppingPoints,
    fetchRidePostBoardingDroppingPoints,
  } = useBoardingDropping();

  useEffect(() => {
    if (!ridePostBoardingDroppingPoints) {
      fetchRidePostBoardingDroppingPoints(); // Fetch data if not already available
    }
  }, [ridePostBoardingDroppingPoints, fetchRidePostBoardingDroppingPoints]);

  useEffect(() => {
    fetchRidePostBoardingDroppingPoints();
  }, []);

  const location = useLocation();

  useEffect(() => {
    const mainValue = new URLSearchParams(location.search);
    const value = mainValue.get("params");
    //console.log({value})
    if (value) {
      try {
        const testdata = JSON.parse(value);
        // console.log({testdata})
        sessionStorage.setItem("key", testdata?.key);
        sessionStorage.setItem("code", testdata?.c_code);
        sessionStorage.setItem(
          "phone",
          "+" + testdata?.c_code + "" + testdata?.phone
        );
        sessionStorage.setItem("userid", testdata?.userid);
        sessionStorage.setItem("fname", testdata?.fname);
        sessionStorage.setItem("lname", testdata?.lname);
        sessionStorage.setItem("email", testdata?.email);
        sessionStorage.setItem("name", testdata?.name);
        sessionStorage.setItem("city_id", testdata?.city_id);
        sessionStorage.setItem("city_cur", testdata?.city_cur);
        sessionStorage.setItem("auth", JSON.stringify(testdata));
      } catch (error) {
        console.log(`User Params Data`, error?.message);
        handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
      }
    } else {
      handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
    }
  }, []);

  const onChangeAddress = (e) => {
    setAddress(e.target.value);
  };

  const Validation = () => {
    let result = true;

    if (address?.length == 0 || address == null || address == undefined) {
      result = false;
      setErr(true);
    }
    return result;
  };

  const detailHandler = (e) => {
    e.preventDefault();
    if (Validation()) {
      const searchDetail = {
        boarding: address,
      };
      setSearchDetail(searchDetail);
      setBookingView(1);
      sessionStorage.setItem("searchdetails", JSON.stringify(searchDetail));
    }
  };

  const handleBookingView = (val) => {
    if (val == 0 && Object.keys(searchDetail).length > 0) {
      setAddress(searchDetail?.boarding);
    }
    setBookingView(val);
  };

  const handleSortCity = (value) => {
    return value.sort((a, b) => a.name.localeCompare(b.name));
  };
  const uniqueCities = useMemo(() => {
    const seen = new Set();
    return handleSortCity(citiesJson).filter((city) => {
      if (seen.has(city.name)) return false;
      seen.add(city.name);
      return true;
    });
  }, [citiesJson]);

  const handleFormViewBack = (val) => {
    const viewCheck = bookingView - val;
    if (viewCheck < 0) {
      setBookingView(0);
      try {
        if (window.AndroidFunction) {
          console.log("Android");
          window.AndroidFunction.postMessage("Finish");
        } else {
          console.log("No Interface available");
        }

        const eventDetail = { message: "Finish", timestamp: Date.now() };
        // Create and dispatch the event
        const event = new CustomEvent("iosCustomEvent", {
          detail: eventDetail,
        });
        document.dispatchEvent(event);
        console.log("Custom event dispatched", eventDetail);
      } catch (error) {
        console.log(`No Interface available Err`, error);
      }
      return;
    }
    setBookingView((prev) => prev - val);
  };

  return (
    <>
    <aside
            className="android_search_form_container_close"
            onClick={() => {
              handleFormViewBack(1);
            }}
          >
            <i className="fas fa-arrow-left"></i>
            <Typography
              variant="h4"
              className="android_search_form_container_heading"
              gutterBottom
              sx={{ textAlign: "center" }}
            >
              Search A Ride
            </Typography>
          </aside>
      {bookingView == 0 && (
        <div>
          <section className="tj-booking-frm android_search_form">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-6 booking_page_main">
                  <img
                    className="booking_page_main_image"
                    src={BookingPageIcon}
                    alt={websiteDetail.title}
                    title={websiteDetail.title}
                  />
                </div>
                <div className="col-md-6 col-sm-6 booking_select_form_main">
                  <div className="tab-content">
                    <div className="tab-pane active" id="point">
                      {handleBack && (
                        <div
                          className="booking_tab_view_selection_back"
                          onClick={() => {
                            handleBack(0);
                          }}
                        >
                          <i className="fas fa-chevron-left"></i>{" "}
                          <span>Back</span>
                        </div>
                      )}
                      <form
                        onSubmit={detailHandler}
                        className="booking-frm"
                        id="User-Form"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        <div className="col-md-12 col-sm-12">
                          <strong
                            style={{
                              marginTop: "10px",
                              marginBottom: "-10px",
                            }}
                          >
                            From
                          </strong>
                          <div className="field-holder border padding-input">
                            {/* <select
                              id="boardingPoints"
                              value={address}
                              onChange={onChangeAddress}
                              className="dropdown_main_select"
                            >
                              <option value="">Select From Location</option>
                              {ridePostBoardingDroppingPoints?.boarding?.map(
                                (value) => (
                                  <option key={value} value={value}>
                                    {value}
                                  </option>
                                )
                              )}
                            </select> */}
                            <Autocomplete
                              options={uniqueCities}
                              getOptionLabel={(option) => {
                                return option.name ?? "";
                              }}
                              value={
                                uniqueCities.find(
                                  (city) => city.name === address
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                onChangeAddress({
                                  target: { value: newValue?.name || null },
                                });
                              }}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) =>
                                  option.name
                                    .toLowerCase()
                                    .includes(inputValue.toLowerCase())
                                )
                              }
                              renderInput={(params) => (
                                <TextField
                                  key={params.id}
                                  {...params}
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  placeholder="Enter From Location"
                                />
                              )}
                              isOptionEqualToValue={(option, value) => {
                                // console.log({option},value)
                                return option.name === value;
                              }}
                            />

                            {err && (address?.length <= 0 || !address) ? (
                              <label
                                htmlFor="u_email"
                                id="u_email-error"
                                className="error form_validation_err"
                                style={{
                                  color: "#e74c3c",
                                  fontWeight: "500",
                                  fontSize: "15px",
                                }}
                              >
                                Select From Location
                              </label>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-12 col-sm-12">
                          <button className="book-btn common_booking_button common_button_border">
                            Search{" "}
                            <i
                              className="fas fa-arrow-circle-right"
                              aria-hidden="true"
                            ></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
      {bookingView == 1 && (
        <SearchRideList
          searchDetail={searchDetail}
          handleView={() => {
            handleBookingView(0);
          }}
        />
      )}
    </>
  );
};

export default SearchRide;
